import { reactive } from 'vue'
import type { Document, DocumentEntityType } from '@/types'

export interface DocumentsState {
  documents: Document[]
  publicDocument: Document | null
  publicAccessEmail: string | null
  isLoading: boolean
  error: string | null
  currentEntityType: DocumentEntityType | null
  currentEntityId: string | null
}

export const getInitialState = (): DocumentsState => ({
  documents: [],
  publicDocument: null,
  publicAccessEmail: null,
  isLoading: false,
  error: null,
  currentEntityType: null,
  currentEntityId: null,
})

export const createState = (): DocumentsState => {
  return reactive(getInitialState())
}

export const resetState = (state: DocumentsState): void => {
  const initial = getInitialState()
  state.documents = initial.documents
  state.publicDocument = initial.publicDocument
  state.publicAccessEmail = initial.publicAccessEmail
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.currentEntityType = initial.currentEntityType
  state.currentEntityId = initial.currentEntityId
}
